// extracted by mini-css-extract-plugin
module.exports = {"social":"Social-module--social--2XHkL"};